export default __webpack_public_path__ + "media/zurb/img/ecommerce/browse-b66d7b611398f12d31ccebf250d11191.png";